import FormationBuilderPage from "../FormationBuilderPage";

const technicienMaintenanceIndustrielleProgram = [
  {
    title: "Habilitation électrique (BR / B1V / BC)",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "Lecture et interprétation de schémas électriques",
    img: "/assets/images/icon/light.svg",
  },
  { title: "Variateurs de vitesse", img: "/assets/images/icon/light.svg" },
  {
    title: "Automates programmables industriels (API)",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Langages GRAFCET / Ladder / LIST",
    img: "/assets/images/icon/component-card.svg",
  },
  { title: "Régulation PID", img: "/assets/images/icon/light.svg" },
  {
    title: "Hydraulique industrielle : distributeurs, vérins, accumulateurs",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Pneumatique : distributeurs, vérins, clapets",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Mécanique : lecture de plans, tolérances, usinage manuel",
    img: "/assets/images/icon/setting.svg",
  },
  { title: "Soudage à l'arc", img: "/assets/images/icon/setting.svg" },
  {
    title: "Méthodologie de diagnostic : QQOQCP, 5 Pourquoi, arbre des causes",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Amélioration continue : TPM / Kaizen / 5S",
    img: "/assets/images/icon/redaction.svg",
  },
  {
    title: "GMAO : gestion des interventions et traçabilité",
    img: "/assets/images/icon/fiche.svg",
  },
  {
    title: "GEMMA et analyse des modes de marche/arrêt",
    img: "/assets/images/icon/rule.svg",
  },
  {
    title: "Outils bureautiques : Word, Excel",
    img: "/assets/images/icon/fiche.svg",
  },
  { title: "Anglais technique", img: "/assets/images/icon/work-women.svg" },
  {
    title: "Posture professionnelle & communication",
    img: "/assets/images/icon/work-women.svg",
  },
  {
    title: "Projets intégrés multi-techno",
    img: "/assets/images/icon/redaction.svg",
  },
  {
    title: "Étude de cas / Projet de fin de cursus",
    img: "/assets/images/icon/fiche.svg",
  },
];

const TechnicienMaintenanceIndustrielle = () => (
  <FormationBuilderPage
    category="BTP-Tertiaire"
    titleColor="#2424FF"
    title="Technicien de Maintenance Industrielle"
    duration={11}
    description={
      <p>
        Grâce au partenariat entre Liora et Vinci Facilities, rejoignez l'un des
        leaders français des services multi-techniques et de la performance
        énergétique des bâtiments en tant que Technicien de Maintenance
        Industrielle, après une formation accélérée de 11 semaines. Performance
        énergétique des bâtiments, maintenance multi-technique, smart building,
        transition environnementale... rythment le quotidien de nos équipes,
        pourquoi pas le vôtre ?
      </p>
    }
    image="/assets/images/home/btp-tertiaire.png"
    formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
    popupFormId="5705be1e-3baf-4d49-9f13-541b1db0c861"
    program={technicienMaintenanceIndustrielleProgram}
  />
);

export default TechnicienMaintenanceIndustrielle;
